import { Component, Input, EventEmitter, Output, OnInit, OnChanges } from '@angular/core';
import { TaskService } from '../../core/service/task.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { TextProcessor } from 'src/app/core/utility/text.processor';

@Component({
  standalone: false,
  selector: 'app-task-force-close',
  templateUrl: './task-force-close.component.html',
  styleUrls: ['./task-force-close.component.scss']
})
export class TaskForceCloseComponent implements OnInit, OnChanges
{
  @Input() public task;
  @Input() public dialogOpened: boolean;

  @Output() public closing = new EventEmitter();
  @Output() public save = new EventEmitter();

  public reason = '';
  public shortTaskName = '';

  constructor(
    private taskService: TaskService,
    private messageHandlerService: MessageHandlerService) { }

  public ngOnInit(): void
  {
    this.reason = '';
  }
  
  public ngOnChanges(): void
  {
    if (this.task != null)
    {
      this.shortTaskName = TextProcessor.truncateText(this.task.name, 35);
    }
    this.reason = '';
  }

  public cancelForceClose(): void
  {   
    this.dialogOpened = false;
    this.closing.emit();
  }

  public forceClose(): void
  {
    this.taskService.forceCloseTask(this.task.id, this.reason).subscribe({
      next: () =>
      {
        this.dialogOpened = false;
        this.save.emit(this.task);
        this.messageHandlerService.displaySuccess('TASK-FORCE-CLOSED-SUCCESSFULLY');
      }
    });
  }

  public closeDialog(): void
  {
    this.closing.emit();
  }
}
